import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React, { useState } from 'react';
import { useDwindle, useMenu } from '../../utils/Hooks.js';
import { A11yMeaningfulLabelContext } from '../A11yMeaningfulLabel/A11yMeaningfulLabelPresentation.js';
import { CardsCustomItemPresentation } from './CardsCustomItemPresentation.js';

var CardsCustomItemWrapper = function CardsCustomItemWrapper(_a) {
  var _b;
  var menuNavigationTree = _a.menuNavigationTree,
    props = __rest(_a, ["menuNavigationTree"]);
  var disabled = props.disabled,
    loading = props.loading;
  var _useDwindle = useDwindle(props),
    _useDwindle2 = _slicedToArray(_useDwindle, 3),
    _useDwindle2$ = _useDwindle2[0],
    hasKeyboardFocus = _useDwindle2$.hasKeyboardFocus,
    hasMouseHover = _useDwindle2$.hasMouseHover,
    clicked = _useDwindle2$.clicked,
    _useDwindle2$2 = _useDwindle2[1],
    setHasKeyboardFocus = _useDwindle2$2.setHasKeyboardFocus,
    setHasMouseHover = _useDwindle2$2.setHasMouseHover,
    _useDwindle2$3 = _useDwindle2[2],
    onMouseDown = _useDwindle2$3.onMouseDown,
    onMouseUp = _useDwindle2$3.onMouseUp,
    onMouseLeave = _useDwindle2$3.onMouseLeave;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasMenuMouseHover = _useState2[0],
    setMenuMouseHover = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasMenuKeyboardFocus = _useState4[0],
    setMenuKeyboardFocus = _useState4[1];
  var menuCallbacks = menuNavigationTree ? useMenu(menuNavigationTree) : undefined;
  return /*#__PURE__*/React.createElement(A11yMeaningfulLabelContext.Provider, {
    value: {
      onMouseHoverChange: setHasMouseHover,
      onKeyboardFocusChange: setHasKeyboardFocus,
      onMouseUp: onMouseUp,
      onMouseDown: onMouseDown,
      onMouseLeave: onMouseLeave,
      disabled: disabled,
      loading: loading,
      isActive: clicked,
      hasMouseHover: hasMouseHover,
      hasKeyboardFocus: hasKeyboardFocus,
      type: "link"
    }
  }, /*#__PURE__*/React.createElement(CardsCustomItemPresentation, Object.assign({}, props, {
    menuCallbacks: menuCallbacks,
    menuNavigationTree: menuNavigationTree,
    hasKeyboardFocus: hasKeyboardFocus,
    hasMouseHover: hasMouseHover || ((_b = menuCallbacks === null || menuCallbacks === void 0 ? void 0 : menuCallbacks[0]) === null || _b === void 0 ? void 0 : _b.open) || hasMenuMouseHover || hasMenuKeyboardFocus,
    onMenuMouseHoverChange: setMenuMouseHover,
    onMenuKeyboardFocusChange: setMenuKeyboardFocus,
    hasMenuMouseHover: hasMenuMouseHover,
    hasMenuKeyboardFocus: hasMenuKeyboardFocus,
    isActive: clicked
  })));
};

export { CardsCustomItemWrapper };
